const endPoint = 'https://sizechart-th.pwa-commerce.com';
//const endPoint = "https://9d2f6acf862b.ngrok-free.app";

const htmlElement = document.getElementsByTagName('html')[0];
const loadingStepFade = 300;
const loadingStepVideo = 3000;
const brandSelectedId = '';
var currentBrandMinCm = 0;
var currentBrandMaxCm = 0;
var currentBrandMinIn = 0;
var currentBrandMaxIn = 0;

const sizeDataSelected = {
	gender: '',
	brandName: '',
	sizeType: '',
	footerLength: '',
	brandSizeValue: '',
	fitPreference: 'fit',
	footLengthFinal: 0,
	footLengthUnit: 'cm',
	footLengthInput: 0,
};

/**
 * Update button text
 */

function buttonLabelUpdate(id, text) {
	document.getElementById(id).innerHTML = text;
}

function getSizesType(sizesBrand, targetScreen) {
	const nextScreen = document.getElementById(targetScreen);
	const tabPriceTypeElement = nextScreen.querySelector('.tpt-sizechart__price-type');
	const tabPriceTypeSizeElement = nextScreen.querySelector('.tpt-size-tab__container');

	if (sizesBrand.length) {
		var priceTypeHtml = '';
		var priceTypeDataHtml = '';

		sizesBrand.forEach((sizeTypeItem, index) => {
			var activeClassTab = '';
			var sizeItem = '';
			var sizeItems = sizeTypeItem.size;

			/**
			 * Get price type to price tab
			 */

			if (index == 0) {
				activeClassTab = 'active';
			}

			priceTypeHtml =
				priceTypeHtml +
				`<tpt-size-tab-item class="tpt-sizechart__price-type--tab ${activeClassTab}" data-target="tpt-size-tab__id-${index}">
							<span class="tpt-sizechart__price-type--item">${sizeTypeItem.size_type}</span>
						</tpt-size-tab-item>`;

			/**
			 * Get brand size data
			 */

			sizeItems.forEach((item) => {
				var sizeValue = item.size_value;
				const activeSize = item.active ? 'tpt-sizechart-size__item--active' : 'tpt-sizechart-size__item--disabled';
				sizeItem = sizeItem + `<tpt-size-item class="tpt-sizechart-size__item ${activeSize}" data-size-type="${sizeTypeItem.size_type}" data-size="${sizeValue}" data-foot-length="${item.cm}">${sizeValue}</tpt-size-item>`;
			});

			priceTypeDataHtml =
				priceTypeDataHtml +
				`<tpt-size-tab-data id="tpt-size-tab__id-${index}" class="tpt-sizechart-sizes__data ${activeClassTab}">
							<div class="tpt-sizechart-sizes">${sizeItem}<span class="tpt-sizechart-size__item-bottom"></span></div>
						</tpt-size-tab-data>`;
		});

		tabPriceTypeElement.innerHTML = priceTypeHtml;
		tabPriceTypeSizeElement.innerHTML = priceTypeDataHtml;
	} else {
		showNoResult();
	}
}

/**
 * Foot length note
 */

function footLengthSelectedNoteUpdate(footLength) {
	const footLengthSelectedNote = window.tptSizeChart.footLengthSelectedNote.replace('__FOOTLENGTH__VALUE__', `${footLength}`);
	document.getElementById('tpt-footlength__selected-note').innerHTML = footLengthSelectedNote;
}

/**
 * Add text for element
 */

function addText(elementId, htmlText) {
	document.getElementById(elementId).innerHTML = htmlText;
}

/**
 * Get size by brand id
 */
function getSizeByBrandId(brandId, navButtonElement) {
	//Auto get size by brand id width current product fit
	const apiGetSizeChartByBrand = `${endPoint}/api/shops/size-chart-by-product/${window.tptSizeChart.productId}?brandId=${brandId}&shopId=${window.tptSizeChart.shopId}`;

	navButtonElement.classList.add('loading');

	fetch(apiGetSizeChartByBrand)
		.then((response) => response.json())
		.then((data) => {
			if (data.status == -1) {
				showNoResult();
			} else {
				const idBrand = data.brand.brand_id;
				const nameBrand = data.brand.brand_name;
				const imageUrlBrand = data.brand.brand_url;
				const sizesBrand = data.brand.sizes;
				const brandSelectedText = window.tptSizeChart.brandSelectedText.replace('__BRAND__', nameBrand);

				if (imageUrlBrand) {
					const brandImageHtml = `<img class="tpt-brand__image-selected" src="${imageUrlBrand}" width="200" height="100" alt="${nameBrand}" >`;

					document.getElementById('tpt-sizechart-brand__selected-brand--selected').innerHTML = `${brandImageHtml}<span class="tpt-sizechart-brand__selected-name">${nameBrand}</span>`;
				}

				const targetScreen = navButtonElement.getAttribute('data-target');

				getSizesType(sizesBrand, targetScreen);

				addText('tpt-sizechart-brand__size-text', brandSelectedText);

				navButtonElement.nextScreen(0);
			}
		})
		.catch((e) => {
			console.error(e);
		})
		.finally(() => {
			navButtonElement.classList.remove('loading');
		});
}

/**
 * Show loading screen
 */

function showLoadingScreen() {
	document.getElementById('tpt-sizechart-screen__loading').classList.add('active');
}

/**
 * Hidden loading screen
 */

function hiddenLoadingScreen() {
	document.getElementById('tpt-sizechart-screen__loading').classList.remove('active');
}

/**
 * Hidden all tab sizechart finder
 */

function hiddenAllTabs() {
	document.getElementById('find-by-brand').classList.add('tpt-sizechart__hidden-tabs');
	document.getElementById('find-by-foot-size').classList.add('tpt-sizechart__hidden-tabs');
}

/**
 * Show all tab sizechart finder
 */
function showAllTabs() {
	document.getElementById('find-by-brand').classList.remove('tpt-sizechart__hidden-tabs');
	document.getElementById('find-by-foot-size').classList.remove('tpt-sizechart__hidden-tabs');
}

function activeCurrentSizeType() {
	//const sizeInput = document.querySelector('input[name^="Size-"]:checked');
	const sizeInput = document.querySelector('input[name^="Size-"]:checked, input[name^="ขนาด-"]:checked');

	if (!sizeInput) return;

	const sizePrefix = sizeInput.value.split(' ')[0];

	const activeSizeTab = document.querySelector(`tpt-size-type-result[data-size-type="${sizePrefix}"]`);

	if (activeSizeTab) {
		activeSizeTab.click();
		activeSizeTab.closest('.pt-sizechart-brand__result-price--type').classList.add('active-by-current-size-type');
	}
}

/**
 * Show result screen
 */
function showResutlScreen() {
	hiddenAllTabs();
	document.getElementById('tpt-sizechart__result').classList.add('active');
}

/**
 * Show no result screen
 */

function showNoResult() {
	document.getElementById('tpt-sizechart-screen__no-result').classList.add('active');
}

/**
 * Hidden no result screen
 */

function hiddenNoResult() {
	document.getElementById('tpt-sizechart-screen__no-result').classList.remove('active');
}

/**
 * Update loading text
 */

function updateLoadingText(loadingText) {
	if (loadingText) {
		document.getElementById('tpt-sizechart-screen__loading-text').innerHTML = loadingText;
	}
}

/**
 * Append size result to result screen
 */

function appendSizeResult(sizeRecommendation, searchType) {
	if (sizeRecommendation.length) {
		var sizeTypeHtml = '';
		var priceTypeDataHtml = '';
		var tabTrigger = '';
		const tabPriceTypeElement = document.querySelector('#tpt-sizechart__result .tpt-sizechart__price-type');
		const tabPriceTypeSizeElement = document.querySelector('#tpt-sizechart__result .pt-sizechart-brand__result-size--selected');

		sizeRecommendation.forEach((sizeTypeItem, index) => {
			var classActive = '';

			if (index == 0) {
				classActive = 'active';
			}

			sizeTypeHtml =
				sizeTypeHtml +
				`<tpt-size-type-result class="tpt-sizechart__price-type--tab ${classActive}" data-target="tpt-size-tab-result__id-${index}" data-brand="${window.tptSizeChart.productVendor}" data-gender="${window.tptSizeChart.productGender}" data-size-type="${sizeTypeItem.type}" data-size-value="${sizeTypeItem.value}">
							<span class="tpt-sizechart__price-type--item">${sizeTypeItem.type}</span>
						</tpt-size-type-result>`;

			priceTypeDataHtml =
				priceTypeDataHtml +
				`<tpt-size-type-data id="tpt-size-tab-result__id-${index}" class="tpt-sizechart-sizes__data-result ${classActive}">
							<div class="tpt-sizechart-sizes--result">${sizeTypeItem.type} ${sizeTypeItem.value}</div>
						</tpt-size-type-data>`;
		});

		tabPriceTypeElement.innerHTML = sizeTypeHtml;
		tabPriceTypeSizeElement.innerHTML = priceTypeDataHtml;

		if (searchType == 'brand') {
			tabTrigger = document.querySelector(`tpt-size-result tpt-size-type-result[data-size-type="${sizeDataSelected.sizeType}"]`);
			const searchResultSring = window.window.tptSizeChart.brandResultDescription;
			const searchResultText = searchResultSring.replace('__BRAND__', sizeDataSelected.brandName).replace('__SIZE_TYPE__', sizeDataSelected.sizeType).replace('__SIZE_VALUE__', sizeDataSelected.brandSizeValue);
			document.getElementById('tpt-sizechart__result-description').innerHTML = searchResultText;
		} else {
			tabTrigger = document.querySelector(`tpt-size-result tpt-size-type-result:first-child`);
			const searchResultSring = window.window.tptSizeChart.footLengthResultDescription;
			const searchResultText = searchResultSring.replace('__FOOT_LENGTH__', sizeDataSelected.footLengthInput).replace('__FOOT_LENGTH_UNIT__', sizeDataSelected.footLengthUnit);
			document.getElementById('tpt-sizechart__result-description').innerHTML = searchResultText;
		}

		if (tabTrigger) {
			tabTrigger.click();
		} else {
			tabTrigger = document.querySelector(`tpt-size-result tpt-size-type-result:first-child`);

			if(tabTrigger){
				tabTrigger.click();
			}
		}
	} else {
		showNoResult();
	}
}

/**
 * Get size recommendation
 */

function getSizeRecommendation(brandName, footLength, fitPreference, searchType) {
	var brandParam = '';
	var fitParam = '';

	if (brandName) {
		brandParam = `&brandname=${brandName}`;
	}

	if (fitPreference) {
		fitParam = `&fit=${fitPreference}`;
	}

	const apiGetSizeRecommendation = `${endPoint}/api/shops/size-chart-by-option?shopId=${window.tptSizeChart.shopId}&productId=${window.tptSizeChart.productId}${brandParam}${fitParam}`;

	const startTime = performance.now();

	fetch(apiGetSizeRecommendation, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ length: footLength }),
	})
		.then((response) => response.json())
		.then((result) => {
			const endTime = performance.now();
			const duration = (endTime - startTime).toFixed(2);
			const delayTime = loadingStepVideo - duration;
			const finalDelayTime = delayTime > 0 ? delayTime : 0;

			if (result.converted_size) {
				const sizeRecommendation = result.converted_size.sizes;

				const finalFootLength = result.converted_size.matched_cm;

				sizeDataSelected.footLengthFinal = finalFootLength;

				if (result.isCrocs) {
					document.getElementById('tpt-sizechart__result--note').classList.add('active');
				}

				setTimeout(() => {
					appendSizeResult(sizeRecommendation, searchType);
					hiddenLoadingScreen();
					activeCurrentSizeType();
					showResutlScreen();
				}, finalDelayTime);
			} else {
				setTimeout(() => {
					hiddenLoadingScreen();
					showNoResult();
				}, finalDelayTime);
			}
		})
		.catch((error) => {
			console.error('Error:', error);
		});
}

/**
 * Update sizechart button
 */

function updateSizechartButton(buttonSizeChart) {
	const key = 'tpt_sizechart_results';
	const currentGender = window.tptSizeChart.productGender;
	const currentBrand = window.tptSizeChart.productVendor;
	let stored = JSON.parse(localStorage.getItem(key)) || [];

	if (stored.length) {
		const sizeResultValue = window.tptSizeChart.sizeResultButtonLabel;

		const matchedItem = stored.find((item) => item.gender === currentGender && item.brandName === currentBrand);

		if (matchedItem) {
			const resultSizeBrand = matchedItem.brandName;
			const resultSizeType = matchedItem.sizeType;
			const resultSizeValue = matchedItem.sizeValue;
			const buttonResultLabel = sizeResultValue.replace('__BRAND__', resultSizeBrand.toLowerCase()).replace('__SIZE_VALUE__', `${resultSizeType} ${resultSizeValue}`);

			document.querySelector('tpt-sizechart-toggle .tpt-sizechart__default-title').innerHTML = `${buttonResultLabel}
						<span class="tpt-sizechart-toggle__icon-edit">
							<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1.5 8.0029H3.62C3.6858 8.00328 3.75103 7.99067 3.81195 7.96579C3.87287 7.9409 3.92828 7.90424 3.975 7.8579L7.435 4.3929L8.855 3.0029C8.90186 2.95642 8.93906 2.90112 8.96445 2.84019C8.98983 2.77926 9.0029 2.71391 9.0029 2.6479C9.0029 2.58189 8.98983 2.51654 8.96445 2.45561C8.93906 2.39468 8.90186 2.33938 8.855 2.2929L6.735 0.147899C6.68852 0.101035 6.63322 0.0638378 6.57229 0.0384535C6.51136 0.0130691 6.44601 0 6.38 0C6.31399 0 6.24864 0.0130691 6.18771 0.0384535C6.12678 0.0638378 6.07148 0.101035 6.025 0.147899L4.615 1.5629L1.145 5.0279C1.09866 5.07462 1.062 5.13003 1.03711 5.19095C1.01223 5.25186 0.99962 5.3171 1 5.3829V7.5029C1 7.63551 1.05268 7.76268 1.14645 7.85645C1.24021 7.95022 1.36739 8.0029 1.5 8.0029ZM6.38 1.2079L7.795 2.6229L7.085 3.3329L5.67 1.9179L6.38 1.2079ZM2 5.5879L4.965 2.6229L6.38 4.0379L3.415 7.0029H2V5.5879ZM9.5 9.0029H0.5C0.367392 9.0029 0.240215 9.05558 0.146447 9.14935C0.0526784 9.24311 0 9.37029 0 9.5029C0 9.63551 0.0526784 9.76268 0.146447 9.85645C0.240215 9.95022 0.367392 10.0029 0.5 10.0029H9.5C9.63261 10.0029 9.75979 9.95022 9.85355 9.85645C9.94732 9.76268 10 9.63551 10 9.5029C10 9.37029 9.94732 9.24311 9.85355 9.14935C9.75979 9.05558 9.63261 9.0029 9.5 9.0029Z" fill="black"/>
							</svg>
						</span>`;

			if (buttonSizeChart) {
				buttonSizeChart.classList.add('active');
			}
		} else {
			let sizeChartSelected = JSON.parse(localStorage.getItem('tpt_sizechart_data_selected')) || [];

			if (sizeChartSelected.gender == window.tptSizeChart.productGender) {
				if (sizeChartSelected) {
					const fitPreference = sizeChartSelected.fitPreference;
					const brandName = window.tptSizeChart.productVendor;
					const footLength = [sizeChartSelected.footLengthFinal];

					const apiGetSizeRecommendation = `${endPoint}/api/shops/size-chart-by-option?shopId=${window.tptSizeChart.shopId}&productId=${window.tptSizeChart.productId}&brandname=${brandName}&fit=${fitPreference}`;

					fetch(apiGetSizeRecommendation, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({ length: footLength }),
					})
						.then((response) => response.json())
						.then((result) => {
							if (result.converted_size) {
								const sizes = result.converted_size.sizes;

								if (sizes) {
									const sizeType = sizeChartSelected.sizeType;

									const resultData = sizes.find((item) => item.type === sizeType);

									if (resultData) {
										const buttonResultLabel = sizeResultValue.replace('__BRAND__', brandName.toLowerCase()).replace('__SIZE_VALUE__', `${sizeType} ${resultData.value}`);

										document.querySelector('tpt-sizechart-toggle .tpt-sizechart__default-title').innerHTML = `${buttonResultLabel}
									<span class="tpt-sizechart-toggle__icon-edit">
										<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M1.5 8.0029H3.62C3.6858 8.00328 3.75103 7.99067 3.81195 7.96579C3.87287 7.9409 3.92828 7.90424 3.975 7.8579L7.435 4.3929L8.855 3.0029C8.90186 2.95642 8.93906 2.90112 8.96445 2.84019C8.98983 2.77926 9.0029 2.71391 9.0029 2.6479C9.0029 2.58189 8.98983 2.51654 8.96445 2.45561C8.93906 2.39468 8.90186 2.33938 8.855 2.2929L6.735 0.147899C6.68852 0.101035 6.63322 0.0638378 6.57229 0.0384535C6.51136 0.0130691 6.44601 0 6.38 0C6.31399 0 6.24864 0.0130691 6.18771 0.0384535C6.12678 0.0638378 6.07148 0.101035 6.025 0.147899L4.615 1.5629L1.145 5.0279C1.09866 5.07462 1.062 5.13003 1.03711 5.19095C1.01223 5.25186 0.99962 5.3171 1 5.3829V7.5029C1 7.63551 1.05268 7.76268 1.14645 7.85645C1.24021 7.95022 1.36739 8.0029 1.5 8.0029ZM6.38 1.2079L7.795 2.6229L7.085 3.3329L5.67 1.9179L6.38 1.2079ZM2 5.5879L4.965 2.6229L6.38 4.0379L3.415 7.0029H2V5.5879ZM9.5 9.0029H0.5C0.367392 9.0029 0.240215 9.05558 0.146447 9.14935C0.0526784 9.24311 0 9.37029 0 9.5029C0 9.63551 0.0526784 9.76268 0.146447 9.85645C0.240215 9.95022 0.367392 10.0029 0.5 10.0029H9.5C9.63261 10.0029 9.75979 9.95022 9.85355 9.85645C9.94732 9.76268 10 9.63551 10 9.5029C10 9.37029 9.94732 9.24311 9.85355 9.14935C9.75979 9.05558 9.63261 9.0029 9.5 9.0029Z" fill="black"/>
										</svg>
									</span>`;
									}
								}
							}

							buttonSizeChart.classList.add('active');
						})
						.catch((error) => {
							console.error('Error:', error);
						});
				}
			} else {
				buttonSizeChart.classList.add('active');
			}
		}
	} else {
		buttonSizeChart.classList.add('active');
	}
}

/**
 * Close modal sizechart
 */

function closeModalSizechart() {
	document.querySelector('#tpt-modal-sizechart-checker [data-close="modal"]').click();
}

/**
 * Start over
 */

function startOver() {
	const modalSizechart = document.getElementById('tpt-modal-sizechart-checker');
	const brandNextText = document.getElementById('tpt-sizechart-brand-selected-text');
	brandNextText.closest('.tpt-sizechart-navigation__button-next').classList.add('disabled');
	brandNextText.innerHTML = window.tptSizeChart.nextLabel;

	const hiddenScreens = ['#tpt-sizechart__result', '#tpt-sizechart-screen__no-result', '#tpt-sizechart-brand__size'];

	modalSizechart.classList.remove('tpt-sizechart-checker__start');

	hiddenScreens.forEach((screen) => {
		modalSizechart.querySelector(screen).classList.remove('active');
	});
}

/**
 * Button toggle size chart modal
 */
if (!customElements.get('tpt-sizechart-toggle')) {
	customElements.define(
		'tpt-sizechart-toggle',
		class TptSizeChartToggle extends HTMLElement {
			constructor() {
				super();

				const buttonSizeChart = this.closest('.tpt-sizechart-checker');
				updateSizechartButton(buttonSizeChart);
				this.addEventListener('click', this.toggleModalSizeChart.bind(this));
			}

			toggleModalSizeChart() {
				const sizeChartModal = this.getAttribute('data-target');
				document.getElementById(sizeChartModal).classList.toggle('show');
				htmlElement.classList.add('open-modal');
			}
		},
	);
}

/**
 * Size chart start button
 */

if (!customElements.get('tpt-sizechart-start')) {
	customElements.define(
		'tpt-sizechart-start',
		class TptSizeChartStart extends HTMLElement {
			constructor() {
				super();

				this.modalSizeChart = document.getElementById('tpt-modal-sizechart-checker');
				this.addEventListener('click', this.startSizeChart.bind(this));
			}

			startSizeChart() {
				var tabFoot;
				const typeValue = this.closest('.tpt-sizechart-checker__first-step').querySelector('input:checked');

				/**
				 * Get all brand fromt API
				 */

				const apiGetAllbrands = `${endPoint}/api/shops/brands?shopId=${window.tptSizeChart.shopId}&product_id=${window.tptSizeChart.productId}`;
				const apiGetBrandMinMax = `${endPoint}/api/shops/foot-length-range/${window.tptSizeChart.productId}?shopId=${window.tptSizeChart.shopId}`;

				if (typeValue.value == 'by-foot') {
					// fetch(apiGetBrandMinMax)
					// 	.then((response) => response.json())
					// 	.then((data) => {
					// 		currentBrandMinCm = data.min_cm;
					// 		currentBrandMaxCm = data.max_cm;
					// 		currentBrandMinIn = (data.min_cm / 2.54).toFixed(1);
					// 		currentBrandMaxIn = (data.max_cm / 2.54).toFixed(1);
					// 	})
					// 	.catch((e) => {
					// 		console.error(e);
					// 	})
					// 	.finally(() => {
					// 		tabFoot = document.querySelector('tpt-sizechart-tab .tpt-sizechart-checker__tabs-list [data-target="find-by-foot-size"]');
					// 		tabFoot.click();
					// 		document.getElementById('tpt-sizechart-foot-length__form').classList.add('active');
					// 		this.modalSizeChart.classList.add('tpt-sizechart-checker__start');
					// 	});

					tabFoot = document.querySelector('tpt-sizechart-tab .tpt-sizechart-checker__tabs-list [data-target="find-by-foot-size"]');
					tabFoot.click();
					document.getElementById('tpt-sizechart-foot-length__form').classList.add('active');
					this.modalSizeChart.classList.add('tpt-sizechart-checker__start');
				} else {
					fetch(apiGetAllbrands)
						.then((response) => response.json())
						.then((data) => {
							const brands = data.data;
							var brandItemHtml = '';

							if (brands) {
								brands.forEach((brand) => {
									var brandImageHtml = '';

									if (brand.url) {
										brandImageHtml = `<img class="tpt-sizechart__brand-image" src="${brand.url}" width="200" height="100" alt="${brand.name}" >`;
									}
									brandItemHtml =
										brandItemHtml +
										`<li>
									<tpt-brand-item class="tpt-sizechart-brands__item" data-brand-image-url="${brand.url}" data-brand-id="${brand._id}" data-brand-name="${brand.name}">
										${brandImageHtml}
										<span class="tpt-sizechart__brand-name">${brand.name}</span>
									</tpt-brand-item>
								</li>`;
								});

								document.getElementById('tpt-sizechart-brands').innerHTML = brandItemHtml;
							} else {
								document.getElementById('tpt-sizechart-brands').innerHTML = `<li class="tpt-sizechart-no-brand">${window.tptSizeChart.noBrandError}</li>`;
							}
						})
						.catch((e) => {
							console.error(e);
						})
						.finally(() => {
							tabFoot = document.querySelector('tpt-sizechart-tab .tpt-sizechart-checker__tabs-list [data-target="find-by-brand"]');
							tabFoot.click();
							document.getElementById('tpt-sizechart-brand__list').classList.add('active');

							this.modalSizeChart.classList.add('tpt-sizechart-checker__start');
						});
				}
			}
		},
	);
}

/**
 * Size chart tab
 */

if (!customElements.get('tpt-sizechart-tab')) {
	customElements.define(
		'tpt-sizechart-tab',
		class TptSizeChartTabs extends HTMLElement {
			constructor() {
				super();

				const tabs = this.querySelectorAll('.tpt-sizechart-checker__tabs-item');

				tabs.forEach((tab) => {
					tab.addEventListener('click', this.showTab.bind(this));
				});
			}

			showTab(event) {
				const currentTab = event.currentTarget;
				const tabContainer = currentTab.getAttribute('data-target');
				const tabContainerElement = document.getElementById(tabContainer);
				const inputFootLength = tabContainerElement.querySelector('.tpt-sizechart__input');

				this.hiddenAllTabs();

				currentTab.classList.add('active');
				tabContainerElement.classList.add('active');

				if (inputFootLength) {
					inputFootLength.focus();
				}
			}

			hiddenAllTabs() {
				const tabItems = this.querySelectorAll('.tpt-sizechart-checker__tabs-item');
				const tabContainers = this.querySelectorAll('.tpt-sizechart-checker__tabs-container');

				tabItems.forEach((tab) => {
					tab.classList.remove('active');
				});

				tabContainers.forEach((tabContainer) => {
					tabContainer.classList.remove('active');
				});
			}
		},
	);
}

/**
 * Button navigation
 */

if (!customElements.get('tpt-sizechart-nav')) {
	customElements.define(
		'tpt-sizechart-nav',
		class TptSizeChartNav extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.gotoScreen.bind(this));
			}

			/**
			 * Next screen without data fetch
			 */
			nextScreen(loadingStepFade) {
				const nextScreen = this.getAttribute('data-target');

				if (nextScreen) {
					const screenContainer = this.closest('.tpt-sizechart-screen');
					screenContainer.classList.add('tpt-sizechart-screen__loading-step');

					setTimeout(() => {
						screenContainer.querySelectorAll('.tpt-sizechart-screen__step').forEach((screen) => {
							screen.classList.remove('active');
						});

						document.getElementById(nextScreen).classList.add('active');
						screenContainer.classList.remove('tpt-sizechart-screen__loading-step');
					}, loadingStepFade);
				}
			}

			gotoScreen() {
				const dataFetchType = this.getAttribute('data-fetch-type');

				if (dataFetchType) {
					if (dataFetchType === 'brand-size-list') {
						const brandSelectedId = this.closest('.tpt-sizechart-screen__step').querySelector('tpt-brand-item.active').getAttribute('data-brand-id');
						getSizeByBrandId(brandSelectedId, this);
					}

					if (dataFetchType === 'get-size-recommendation') {
						const brandName = sizeDataSelected.brandName;
						const footLength = sizeDataSelected.footerLength.split(',');
						const fitPreference = sizeDataSelected.fitPreference;
						const loadingText = window.tptSizeChart.brandSizeLoading.replace('__BRAND__', brandName).replace(/\n/g, '<br>');

						updateLoadingText(loadingText);

						this.nextScreen(0);
						getSizeRecommendation(brandName, footLength, fitPreference, 'brand');
					}
				} else {
					this.nextScreen(loadingStepFade);
				}
			}
		},
	);
}

/**
 * Brand item
 */

if (!customElements.get('tpt-brand-item')) {
	customElements.define(
		'tpt-brand-item',
		class TptBrandItem extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.activeBrand.bind(this));
			}

			activeBrand() {
				document.querySelectorAll('tpt-brand-item').forEach((item) => {
					item.classList.remove('active');
				});

				this.classList.add('active');
				sizeDataSelected.brandName = this.getAttribute('data-brand-name');
				sizeDataSelected.gender = window.tptSizeChart.productGender;
				sizeDataSelected.brandImageUrl = this.getAttribute('data-brand-image-url');
				this.closest('.tpt-sizechart-screen__step').querySelector('.tpt-sizechart-navigation__button-next').classList.remove('disabled');

				const buttonBrandSelectedString = window.tptSizeChart.brandSelectedButtonLabel;
				//const buttonLabelUpdateText = buttonBrandSelectedString.replace('__BRAND__', sizeDataSelected.brandName);
				const buttonLabelUpdateText = window.tptSizeChart.nextLabel;

				buttonLabelUpdate('tpt-sizechart-brand-selected-text', buttonLabelUpdateText);
			}
		},
	);
}

/**
 * Size item
 */

if (!customElements.get('tpt-size-item')) {
	customElements.define(
		'tpt-size-item',
		class TptSizeItem extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.activeSizeItem.bind(this));
			}

			activeSizeItem() {
				var brandImageHtml = '';

				document.querySelectorAll('tpt-size-item').forEach((item) => {
					item.classList.remove('active');
				});

				this.classList.add('active');

				sizeDataSelected.footerLength = this.getAttribute('data-foot-length');
				sizeDataSelected.sizeType = this.getAttribute('data-size-type');
				sizeDataSelected.brandSizeValue = this.getAttribute('data-size');

				if (sizeDataSelected.brandImageUrl) {
					brandImageHtml = `<img class="tpt-sizechart-brand__image-selected" src="${sizeDataSelected.brandImageUrl}" width="200" height="100" alt="${sizeDataSelected.brandName}" />`;
				}

				document.getElementById('tpt-sizechart-brand__fit-wide-image').innerHTML = brandImageHtml;
				document.getElementById('tpt-sizechart-brand__fit-wide-size').innerHTML = `${this.getAttribute('data-size-type')} ${this.getAttribute('data-size')}`;

				this.closest('.tpt-sizechart-screen__step').querySelector('.tpt-sizechart-navigation__button-next').classList.remove('disabled');

				const sizeSelectedNoteString = window.tptSizeChart.sizeSelectedNote;
				const sizeSelectedNoteText = sizeSelectedNoteString.replace('__SIZE_TYPE__', sizeDataSelected.sizeType).replace('__SIZE_VALUE__', sizeDataSelected.brandSizeValue).replace('__BRAND__', sizeDataSelected.brandName);
				document.getElementById('tpt-brand-size__selected-note').innerHTML = sizeSelectedNoteText;
			}
		},
	);
}

/**
 * Size tab
 */

if (!customElements.get('tpt-size-tab-item')) {
	customElements.define(
		'tpt-size-tab-item',
		class TptSizeTabItem extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.showTab.bind(this));
			}

			showTab() {
				const tabContainer = this.closest('tpt-size-tab');
				const allTab = tabContainer.querySelectorAll('tpt-size-tab-item');
				const allTabData = tabContainer.querySelectorAll('tpt-size-tab-data');

				allTab.forEach((tab) => {
					tab.classList.remove('active');
				});

				allTabData.forEach((tabData) => {
					tabData.classList.remove('active');
				});

				this.classList.add('active');

				const tabDataId = this.getAttribute('data-target');

				document.getElementById(tabDataId).classList.add('active');
			}
		},
	);
}

/**
 * Fit or wide options
 */

if (!customElements.get('tpt-fit-wide-options')) {
	customElements.define(
		'tpt-fit-wide-options',
		class TptFitWideOptions extends HTMLElement {
			constructor() {
				super();

				this.options = this.querySelectorAll('tpt-fit-wide-option');

				this.options.forEach((option) => {
					option.addEventListener('click', this.optionSelected.bind(this));
				});
			}

			optionSelected(event) {
				const selectedOption = event.currentTarget;

				this.options.forEach((option) => {
					option.classList.remove('active');
				});

				selectedOption.classList.add('active');
				sizeDataSelected.fitPreference = selectedOption.getAttribute('data-fit-wide');
			}
		},
	);
}

/**
 * Form foot length
 */

if (!customElements.get('tpt-foot-length-form')) {
	customElements.define(
		'tpt-foot-length-form',
		class TptSizeChartFootLengthForm extends HTMLElement {
			constructor() {
				super();

				this.buttonFind = this.querySelector('tpt-find-foot-length');
				this.inputLength = this.querySelector('.tpt-sizechart__input');
				this.lengthTypes = this.querySelectorAll('tpt-length-type');
				this.inputLength.addEventListener('keyup', this.changeInputValue.bind(this));
				this.buttonFind.addEventListener('click', this.findSize.bind(this));

				this.lengthTypes.forEach((item) => {
					item.addEventListener('click', this.convertLength.bind(this));
				});
			}

			// checkSizeError(finalValue, typeValue) {
			// 	const stringError = window.tptSizeChart.footLengthOutRangeNote;
			// 	const footLengthErrorElement = document.getElementById('tpt-footlength__size-error');
			// 	const isCm = typeValue === 'cm';
			// 	const min = isCm ? currentBrandMinCm : currentBrandMinIn;
			// 	const max = isCm ? currentBrandMaxCm : currentBrandMaxIn;
			// 	const unit = isCm ? 'cm' : 'in';

			// 	const isInvalid = finalValue < min || finalValue > max;

			// 	if (isInvalid) {
			// 		const stringErrorFinal = stringError.replace('__FOOTLENG_MIN__', `${min} ${unit}`).replace('__FOOTLENG_MAX__', `${max} ${unit}`);

			// 		footLengthErrorElement.innerHTML = stringErrorFinal;
			// 	}

			// 	footLengthErrorElement.classList.toggle('active', isInvalid);
			// 	this.buttonFind.classList.toggle('disabled', isInvalid);
			// }

			changeInputValue() {
				const value = parseFloat(this.inputLength.value) || 0;
				const unit = this.closest('.tpt-sizechart-screen__step').querySelector('tpt-length-type.active').getAttribute('data-type');
				this.buttonFind.classList.toggle('disabled', !this.inputLength.value);

				footLengthSelectedNoteUpdate(`${value} ${unit}`);

				//this.checkSizeError(value, unit);
			}

			convertLength(event) {
				var lengthType = event.currentTarget;
				var footLengthSelectedNoteString = '';

				if (!lengthType.classList.contains('active')) {
					let value = parseFloat(this.inputLength.value) || 0;

					this.lengthTypes.forEach((item) => item.classList.remove('active'));
					lengthType.classList.add('active');

					const typeValue = lengthType.dataset.type;

					value = typeValue === 'inch' ? value / 2.54 : value * 2.54;

					const finalValue = Number(value.toFixed(1));

					this.inputLength.value = finalValue;

					footLengthSelectedNoteString = `${finalValue} ${typeValue}`;

					//this.checkSizeError(finalValue, typeValue);
				}

				footLengthSelectedNoteUpdate(footLengthSelectedNoteString);
			}

			findSize() {
				const footerLengthType = this.closest('tpt-foot-length-form').querySelector('tpt-length-type.active').getAttribute('data-type');
				let footLengthValue = parseFloat(this.inputLength.value) || 0;
				let baseFootLengthValue = footLengthValue;

				if (footerLengthType === 'in') {
					footLengthValue = footLengthValue * 2.54;
				}

				const finalFootLengthValue = Number(footLengthValue.toFixed(1));
				sizeDataSelected.footLengthUnit = footerLengthType;
				sizeDataSelected.footLengthInput = baseFootLengthValue;
				const brandName = '';
				const footLength = [finalFootLengthValue];
				const fitPreference = '';
				const loadingText = window.tptSizeChart.footLengthLoading.replace(/\n/g, '<br>');

				hiddenAllTabs();
				updateLoadingText(loadingText);
				showLoadingScreen();
				getSizeRecommendation(brandName, footLength, fitPreference, 'footlength');
			}
		},
	);
}

/**
 * Resutl tab
 */

if (!customElements.get('tpt-size-type-result')) {
	customElements.define(
		'tpt-size-type-result',
		class TptResutlTab extends HTMLElement {
			constructor() {
				super();

				this.tabContainer = this.closest('tpt-size-result');
				this.addEventListener('click', this.showTab.bind(this));
			}

			showTab() {
				const tabContainer = this.getAttribute('data-target');
				const tabContainerElement = this.tabContainer.querySelector(`#${tabContainer}`);

				this.hiddenAllTabs();

				this.classList.add('active');
				tabContainerElement.classList.add('active');

				const finishString = window.tptSizeChart.finishLabel;

				const sizeType = this.getAttribute('data-size-type');
				const sizeValue = this.getAttribute('data-size-value');
				const finishText = finishString.replace('__SIZE_TYPE__', sizeType).replace('__SIZE_VALUE__', sizeValue);

				document.getElementById('tpt-sizechart-finish').innerHTML = finishText;
			}

			hiddenAllTabs() {
				const tabItems = this.tabContainer.querySelectorAll('tpt-size-type-result');
				const tabContainers = this.tabContainer.querySelectorAll('tpt-size-type-data');

				tabItems.forEach((tab) => {
					tab.classList.remove('active');
				});

				tabContainers.forEach((tabContainer) => {
					tabContainer.classList.remove('active');
				});
			}
		},
	);
}

/**
 * Finish button
 */

if (!customElements.get('tpt-sizechart-finish')) {
	customElements.define(
		'tpt-sizechart-finish',
		class TptFinish extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.finish.bind(this));
			}

			finish() {
				const sizeDataTab = this.closest('#tpt-sizechart__result').querySelector('tpt-size-type-result.active');

				const resultGender = sizeDataTab.getAttribute('data-gender');
				const resultBrand = sizeDataTab.getAttribute('data-brand');
				const resultSizeType = sizeDataTab.getAttribute('data-size-type');
				const resultSizeValue = sizeDataTab.getAttribute('data-size-value');

				const resultData = {
					gender: resultGender,
					brandName: resultBrand,
					sizeType: resultSizeType,
					sizeValue: resultSizeValue,
				};

				const key = 'tpt_sizechart_results';
				let stored = JSON.parse(localStorage.getItem(key)) || [];

				const index = stored.findIndex((item) => item.gender === resultData.gender && item.brandName === resultData.brandName);

				if (index !== -1) {
					stored[index] = {
						...stored[index],
						...resultData,
					};
				} else {
					stored.push(resultData);
				}

				sizeDataSelected.sizeType = resultSizeType;
				sizeDataSelected.gender = window.tptSizeChart.productGender;

				localStorage.setItem(key, JSON.stringify(stored));

				localStorage.setItem('tpt_sizechart_data_selected', JSON.stringify(sizeDataSelected));

				updateSizechartButton();
				closeModalSizechart();
			}
		},
	);
}

/**
 * Start over button
 */

if (!customElements.get('tpt-sizechart-start-over')) {
	customElements.define(
		'tpt-sizechart-start-over',
		class TptStartOver extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.startOver.bind(this));
			}

			startOver() {
				startOver();
			}
		},
	);
}

/**
 * Trigger click sizechart default
 */

if (!customElements.get('tpt-trigger-size-modal')) {
	customElements.define(
		'tpt-trigger-size-modal',
		class TptSizeChartDefaultModal extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.showSizeChartDefaultModal.bind(this));
			}

			showSizeChartDefaultModal() {
				closeModalSizechart();

				setTimeout(() => {
					document.querySelector('.ks-chart-container .ks-chart-modal-link').click();
				}, 400);
			}
		},
	);
}
